import { useStaticQuery, graphql } from "gatsby"

export const useSizeGuideMetadata = ({size}) => {

  const arrayToObject1 = (arr, key, size) => {
    return (arr.reduce((obj, item) => {
        obj[item[key]] = item
        return obj
    }, {}))[size]
  } 
  const { allDatoCmsSizeguide } = useStaticQuery(
    graphql`
      query SizeGuideQuery {
        allDatoCmsSizeguide {
          nodes {
            description
            code
            productType
            sizeGroups {
              sizeGroup
              size {
                sizeType
                size
              }
            }
          }
        }
      }
    `
  )
  return arrayToObject1(allDatoCmsSizeguide.nodes, 'code', size)
}